<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-add-tab-info">

    <vs-popup :title="$t('MODULES.addMenu')" :active.sync="showAddMenuPopUp">
      <div class="vx-row" id="add-menu">
        <div class="vx-col w-full mt-2 mb-3">
          <vs-input :label="$t('MODULES.moduleNameInMenu')" v-model="menuTitle" class="w-full" type="text"
            name="menu-title" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
          <!-- <div class="mt-8 flex flex-wrap" style="float: left;"> -->
          <vs-button class="ml-auto mt-2" @click="saveMenu">{{ $t('MODULES.submit') }}</vs-button>
          <!-- </div> -->
        </div>
      </div>
    </vs-popup>

    <div class="mt-5">
      <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
        :finishButtonText="$t('MODULES.submit')" @on-complete="formSubmitted">
        <tab-content :title="$t('MODULES.basic_data')" class="mb-5" icon="feather icon-home"
          :before-change="validateStep1">

          <!-- tab 1 content -->
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-5">
              <label class="vs-input--label">{{ $t('MODULES.moduleType') }}</label>
              <v-select v-model="moduleType" :options="moduleTypes" label="name" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input :label="$t('MODULES.name')" v-model="name" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input :label="$t('MODULES.prefix')" v-model="prefix" class="w-full" maxLength="3"
                @input="setPrefix" />
            </div>
            <div class="vx-col md:w-1/3 w-full" v-show="showCanViewAndCanAssign">
              <div class="mt-4">
                <label class="vs-input--label">{{ $t('MODULES.usersCanAssignRecordsTo') }}</label>
                <v-select v-model="canAssignValue" label="label" :clearable="false" :options="canAssignOptions"
                  name="can_view" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full" v-show="showCanViewAndCanAssign">
              <div class="mt-4">
                <label class="vs-input--label">{{ $t('MODULES.usersCanViewRecordsOf') }}</label>
                <v-select v-model="canViewValue" :clearable="false" :options="canViewOptions" name="can_assign"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5" v-show="showColumnsOnForm">
              <label class="vs-input--label">{{ $t('MODULES.columnsInForm') }}</label>
              <v-select v-model="columnsOnForm" :options="columnsOnFormOptions" label="name" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5" v-show="showLinesPerPage">
              <label class="vs-input--label">{{ $t('MODULES.rowsPerPage') }}</label>
              <v-select v-model="linesByPage" :options="linesByPageOptions" label="name" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5" v-show="showIcons">
              <label class="vs-input--label">{{ $t('MODULES.icon') }}</label>
              <v-select class="icon-select" v-model="icon" :options="iconOptions" label="name">
                <template v-slot:option="option">
                  <feather-icon :icon="option.value" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" /> {{
      option.name }}
                </template>
              </v-select>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showRequireAuthentication">
              <label class="vs-input--label">{{ $t('MODULES.requiresAuthentication') }}</label>
              <ul class="con-s w-full mb-2">
                <li>
                  <vs-switch v-model="requireAuthentication" class="mt-2" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showColorCustomizer">
              <label class="vs-input--label">{{ $t('MODULES.calendarEventColor') }}</label>
              <ul>
                <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2"
                    v-model="customPrimaryColor" type="color" /></li>
              </ul>
            </div>
            <div class="vx-col md:w-1/1 w-full" style="margin-top: -10px!important;">
              <vs-textarea v-model="description" :label="$t('MODULES.description')" class="mb-0 md:mt-10 mt-6"
                rows="3" />
            </div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content :title="$t('MODULES.appearance')" class="mb-5" icon="feather icon-camera" v-if="showAppearanceTab">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="tableStripped" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.striped_table')" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="manageRows" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.manage_displayed_rows')" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="searchField" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.search_field_in_table')" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="additionalInformation" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.additionalInformation')" />
              </vx-input-group>
            </div>
          </div>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content :title="$t('MODULES.export')" class="mb-5" icon="feather icon-download" v-if="showExportTab"
          :before-change="validateStep3">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportPdf" />
                  </div>
                </template>
                <vs-input :value="$t('MODULES.exportTableToPDF')" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportExcel" />
                  </div>
                </template>
                <vs-input :value="$t('MODULES.exportTableToExcel')" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportCsv" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.exportTableToCSV')" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="copyTableData" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.copyTableData')" />
              </vx-input-group>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <label for="" class="vs-input--label"></label>
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="print" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.print')" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full" v-if="print">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <vs-input v-model="printButtonLabel" :label="$t('MODULES.buttonLabel')" />
              </vx-input-group>
            </div>
            <div class="vx-col" v-if="print">
              <label for="" class="vs-input--label">{{ $t('MODULES.maximumTimeout') }}</label>
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <vs-input-number v-model="maxPrintTimeout" :min="10" />
              </vx-input-group>
            </div>
          </div>
        </tab-content>

        <!-- tab 4 content -->
        <tab-content :title="$t('MODULES.list')" class="mb-5" icon="feather icon-list" v-if="showListTab">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="collapsedLists" />
                  </div>
                </template>

                <vs-input value="'Listas minimizadas'" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="addList" />
                  </div>
                </template>

                <vs-input value="'Adicionar listas'" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="showList" />
                  </div>
                </template>

                <vs-input value="'Exibir listas'" />
              </vx-input-group>

            </div>
          </div>
        </tab-content>

      </form-wizard>
      <br><br>
    </div>
  </div>

  <!-- Save & Reset Button -->
  <!-- <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/users')">Cancel</vs-button>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import vSelect from 'vue-select'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { setApplicationLocalStorageItem, performFetch } from '../../../helpers'

export default {
  components: {
    vSelect,
    FormWizard,
    TabContent
  },
  data() {
    return {
      showRequireAuthentication: true,
      showColorCustomizer: false,
      customPrimaryColor: '#3DC9B3',
      showAppearanceTab: true,
      showExportTab: true,
      showListTab: true,
      alreadyTriedMenu: false,
      showAddMenuPopUp: false,
      name: '',
      prefix: '',
      icon: null,
      iconOptions: [],
      moduleType: null,
      moduleTypes: [],
      columnsOnForm: 4,
      columnsOnFormOptions: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
      ],
      linesByPage: 10,
      linesByPageOptions: [
        10,
        15,
        20,
        50
      ],
      showColumnsOnForm: true,
      showLinesPerPage: true,
      showCanViewAndCanAssign: true,
      showIcons: true,
      requireAuthentication: true,
      description: '',
      tableStripped: true,
      manageRows: true,
      searchField: true,
      additionalInformation: true,
      exportPdf: true,
      exportExcel: true,
      exportCsv: true,
      print: false,
      printButtonLabel: '',
      maxPrintTimeout: 10,
      copyTableData: true,
      canAssignValue: { label: this.$t('MODULES.canViewValue'), value: 1 },
      canViewValue: { label: this.$t('MODULES.canViewValue'), value: 1 },
      canAssignOptions: [
        { label: this.$t('MODULES.canViewValue'), value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'), value: 2 },
        { label: this.$t('MODULES.onlySubordinateRole'), value: 3 }
      ],
      canViewOptions: [
        { label: this.$t('MODULES.canViewValue'), value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'), value: 2 },
        { label: this.$t('MODULES.userGroup'), value: 3 },
        { label: this.$t('MODULES.userGroupAndSameOrSubordinateRole'), value: 4 },
        { label: this.$t('MODULES.onlyYourUser'), value: 5 }
      ],
      addList: true,
      collapsedLists: true,
      showList: true,
      menuTitle: '',
      addModuleMenu: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
    // selectedRole: {
    //   set(obj) {
    //     this.selectedRole = obj
    //   },
    //   get() {
    //     this.selectedRole = obj
    //   }
    // }
  },
  async created() {
    this.$vs.loading({ type: 'default' })
    await this.viewParameters()
    this.$vs.loading.close()
  },
  watch: {
    moduleType(newValue) {
      if (newValue.hasOwnProperty('name') && (newValue.name === 'Calendário' || newValue.name === 'Kanban')) {
        this.showAppearanceTab = false
        this.showExportTab = false
        this.showListTab = false
        this.showColumnsOnForm = false
        this.showLinesPerPage = false
        this.showIcons = false
        this.showColorCustomizer = false
        this.showCanViewAndCanAssign = true
      } else if (newValue.name === 'Único registro') {
        this.showAppearanceTab = false
        this.showExportTab = false
        this.showListTab = false
        this.showColumnsOnForm = false
        this.showLinesPerPage = false
        this.showIcons = true
        this.showColorCustomizer = false
        this.showCanViewAndCanAssign = false
      } else if (newValue.hasOwnProperty('name') && (newValue.name === 'Lista')) {
        this.showAppearanceTab = true
        this.showExportTab = true
        this.showListTab = true
        this.showColumnsOnForm = true
        this.showLinesPerPage = true
        this.showIcons = true
        this.showColorCustomizer = false
        this.showCanViewAndCanAssign = true
      }

      if (newValue.hasOwnProperty('name') && newValue.name === 'Calendário') {
        this.showColorCustomizer = true
      }

      if (newValue.hasOwnProperty('name') && newValue.name === 'Kanban') {
        this.requireAuthentication = true
        this.showRequireAuthentication = false
        this.showIcons = true
      }
    }
  },
  methods: {
    validateStep1() {

      if (this.name === '' || !this.name) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.prefix === '' || !this.prefix) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.prefix') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.prefix.length < 3) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.prefixFieldCharacters'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.moduleType.name !== 'Calendário') {

        if (this.columnsOnForm === '' || !this.columnsOnForm) {

          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.formColumnsFieldIsRequired'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false

        }

        if (this.linesByPage === '' || !this.linesByPage) {

          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.rows_per_page') }),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false

        }

        if (this.icon === '' || !this.icon) {

          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.icon') }),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false

        }

      }

      if (this.moduleType === '' || !this.moduleType) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.type') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      return true
    },
    validateStep3() {

      if (this.print && (this.printButtonLabel === '' || this.printButtonLabel === null)) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.buttonLabel') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.print && (this.maxPrintTimeout === '' || this.maxPrintTimeout === null)) {

        this.$vs.notify({
          title: this.$t('MODULES.hashInvalidTitle'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.maximumTimeout') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      return true

    },
    setPrefix(val) {
      this.prefix = val.toUpperCase()
    },
    async viewParameters() {
      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_add_application_module_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (responseData) => {

              this.iconOptions = responseData.parameters.icons
              this.moduleTypes = responseData.parameters.module_types

            })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: this.$t('MODULES.operationNotPerformed'),
              text: this.$t('MODULES.UserRegisterError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }

          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.operationNotPerformed'),
            text: this.$t('MODULES.UserRegisterError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    addMenu() {
      this.showAddMenuPopUp = true
    },
    rejectMenu() {
      this.alreadyTriedMenu = true
      this.formSubmitted()
    },
    saveMenu() {

      if (!this.menuTitle) {
        this.$vs.notify({
          title: this.$t('MODULES.attention'),
          text: this.$t('MODULES.menuNameIsRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }

      this.addModuleMenu = true
      this.showAddMenuPopUp = false
      this.alreadyTriedMenu = true
      this.formSubmitted()
    },
    async formSubmitted() {

      if (this.moduleType.hasOwnProperty('name') && (this.moduleType.name === 'Lista' || this.moduleType.name === 'Único registro' || this.moduleType.name === 'Kanban')) {
        if (!this.alreadyTriedMenu) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: this.$t('MODULES.addMenu'),
            text: this.$t('MODULES.addToMainMenuPrompt'),
            accept: this.addMenu,
            cancel: this.rejectMenu,
            close: this.rejectMenu,
            acceptText: 'Adicionar'
          })

          return
        }
      }

      this.$vs.loading({
        type: 'default'
      })

      let icon = null

      if (this.icon !== null && this.icon.hasOwnProperty('hash')) {
        icon = this.icon.hash
      }

      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module: {
      //         name: this.name,
      //         prefix: this.prefix,
      //         columns_on_form: this.columnsOnForm,
      //         type_hash: this.moduleType.hash,
      //         icon_hash: icon,
      //         lines_per_page: this.linesByPage,
      //         require_authentication: this.requireAuthentication,
      //         description: this.description,
      //         add_menu: this.addModuleMenu,
      //         menu_title: this.menuTitle,
      //         color: this.customPrimaryColor,
      //         enable_print: this.print,
      //         print_button_label: this.printButtonLabel,
      //         max_print_timeout: this.maxPrintTimeout,
      //         can_assign_type_id: this.canAssignValue.value,
      //         can_view_type_id: this.canViewValue.value
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_add_application_module',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module: {
            name: this.name,
            prefix: this.prefix,
            columns_on_form: this.columnsOnForm,
            type_hash: this.moduleType.hash,
            icon_hash: icon,
            lines_per_page: this.linesByPage,
            require_authentication: this.requireAuthentication,
            description: this.description,
            add_menu: this.addModuleMenu,
            menu_title: this.menuTitle,
            color: this.customPrimaryColor,
            enable_print: this.print,
            print_button_label: this.printButtonLabel,
            max_print_timeout: this.maxPrintTimeout,
            can_assign_type_id: this.canAssignValue.value,
            can_view_type_id: this.canViewValue.value
          }
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {

              // await fetch(this.$store.state.auth.api_url, {
              //   method: 'POST', headers: {"Content-Type": "application/json"},
              //   body: JSON.stringify({
              //     command: 'get_application_user_mainmenu',
              //     parameters: {
              //       application_token: this.$store.state.auth.app_token,
              //       session_token: this.$store.state.auth.token
              //     }
              //   })
              // })
              await performFetch(this.$store.state.auth.api_url, {
                command: 'get_application_user_mainmenu',
                parameters: {
                  application_token: this.$store.state.auth.app_token,
                  session_token: this.$store.state.auth.token
                }
              })
                .then(async (response) => {
                  if (response.status === 200) {
                    await response.json().then(async (response) => {

                      await this.$store.dispatch('auth/buildApplicationMenu', response.mainmenu)

                      this.$vs.loading.close()

                      this.$vs.notify({
                        title: this.$t('MODULES.operationCompletedTitle'),
                        text: 'Módulo cadastrado com sucesso!',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                      })

                      this.$store.dispatch('auth/reloadState')

                      this.$router.push('/module-management')
                    })
                  } else if (response.status == 401) {
                    this.$vs.loading.close()
                    setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                    store.dispatch('auth/signOut')
                  } else {
                    this.$vs.loading.close()
                    this.$vs.notify({
                      title: this.$t('MODULES.FailedOperation'),
                      text: 'O módulo foi cadastrado, porém ocorreu um erro ao atualizar o Menu Principal',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                  }
                })
                .catch((error) => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: this.$t('MODULES.FailedOperation'),
                    text: this.$t('MODULES.moduleRegisteredError'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })
            })
          } else if (response.status == 400) {
            await response.json()
              .then(async (response) => {
                this.$vs.loading.close()
                if (response.message === 'Module Name Already Exists') {
                  this.$vs.notify({
                    title: this.$t('MODULES.FailedOperation'),
                    text: this.$t('MODULES.moduleAlreadyExists'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                  })


                } else if (response.message === 'Module Prefix Already Exists') {
                  this.$vs.notify({
                    title: this.$t('MODULES.FailedOperation'),
                    text: this.$t('MODULES.modulePrefixExists'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                  })


                }
              })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorRegisteringModule'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: this.$t('MODULES.errorRegisteringModule'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
<style scoped>
.icon-select>>>.vs__dropdown-menu {

  height: 150px !important;
}
</style>
